import { ThemeOptions } from '@mui/material';

export const typography: ThemeOptions['typography'] = {
  fontFamily:
    'Open Sans,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
  h1: {
    fontWeight: 700,
    textTransform: 'uppercase',
    lineHeight: 1,
  },
  h2: {
    fontWeight: 700,
    textTransform: 'uppercase',
    lineHeight: 1,
  },
  h3: {
    fontWeight: 700,
    textTransform: 'uppercase',
    lineHeight: 1,
  },
  h4: {
    fontWeight: 700,
    textTransform: 'uppercase',
    lineHeight: 1,
  },
  h5: {
    fontWeight: 700,
    textTransform: 'uppercase',
    lineHeight: 1,
  },
  h6: {
    fontWeight: 700,
    lineHeight: 1.2,
  },
  subtitle1: {
    fontWeight: 700,
    lineHeight: 1.125,
  },
  subtitle2: {
    fontWeight: 700,
    lineHeight: 1.286,
  },
  body1: {
    fontWeight: 600,
    lineHeight: 1.25,
  },
  body2: {
    fontWeight: 600,
    lineHeight: 1.286,
  },
  caption: {
    fontWeight: 600,
    lineHeight: 1.167,
  },
  overline: {
    fontWeight: 600,
    fontSize: '0.63rem',
    lineHeight: 1,
    letterSpacing: '0.1rem',
  },
  button: {
    fontWeight: 700,
  },
};
